import script from "./DashboardNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardNotifications.vue?vue&type=script&setup=true&lang=js"

import "./DashboardNotifications.vue?vue&type=style&index=0&id=29467100&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_admin_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29467100"]])

export default __exports__